var map = {
	"./1lives.svg": 440,
	"./2lives.svg": 441,
	"./3lives.svg": 442
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 439;


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg ^\.\/.*lives\.svg$
// module id = 439
// module chunks = 1 4